/** Avoid refetching shop lists when returning from /detail (component remounts). */
let servicesFetchKey = "";
let productsFetchKey = "";

const servicesKey = (
  vehicleId: number,
  lang: string,
  page: number,
  limit: number,
  categoryId?: string | null,
  sort?: string | null
) => `${vehicleId}:${lang}:${page}:${limit}:${categoryId ?? "all"}:${sort ?? ""}`;

const productsKey = (
  lang: string,
  page: number,
  limit: number,
  categoryId?: string | null,
  sort?: string | null
) => `${lang}:${page}:${limit}:${categoryId ?? "all"}:${sort ?? ""}`;

export const shouldSkipServicesFetch = (
  vehicleId: number,
  lang: string,
  page: number,
  limit: number,
  categoryId: string | null,
  status: string,
  sort?: string | null
) => {
  const key = servicesKey(vehicleId, lang, page, limit, categoryId, sort);
  if (key !== servicesFetchKey) return false;
  return status === "succedded" || status === "loading" || status === "rejected";
};

export const markServicesFetched = (
  vehicleId: number,
  lang: string,
  page: number,
  limit: number,
  categoryId: string | null,
  sort?: string | null
) => {
  servicesFetchKey = servicesKey(vehicleId, lang, page, limit, categoryId, sort);
};

export const shouldSkipProductsFetch = (
  lang: string,
  page: number,
  limit: number,
  categoryId: string | null,
  status: string,
  sort?: string | null
) => {
  const key = productsKey(lang, page, limit, categoryId, sort);
  if (key !== productsFetchKey) return false;
  return status === "succedded" || status === "loading" || status === "rejected";
};

export const markProductsFetched = (
  lang: string,
  page: number,
  limit: number,
  categoryId: string | null,
  sort?: string | null
) => {
  productsFetchKey = productsKey(lang, page, limit, categoryId, sort);
};

export const invalidateServicesCache = () => {
  servicesFetchKey = "";
};

export const invalidateProductsCache = () => {
  productsFetchKey = "";
};
